import Editor from 'draft-js-plugins-editor'
import React from 'react'

import styles from './styles/SettingEditor'

const PLAIN_WIDTH = 550 // px
const RICH_WIDTH = 550 // px

const PLACEHOLDER_TEXT = {
  subject: 'Type subject here',
  body:
    'Enter text for message here. Use the @ symbol to add variables like: @patient_first_name.',
}

const bodyFieldStyles = Object.assign(
  {},
  styles.plainTextEditorContainer,
  styles.minHeight100px,
)

// TODO: clean up these prop names
const PlainTextEditor = ({
  bodyState,
  handleFocus,
  handleSearchChange,
  isEmail,
  isTemplate,
  mentionableData,
  MentionSuggestions,
  plugins,
  subjectState,
  updateBodyState,
  updateSubjectState,
  customBodyPlaceholder,
  customSubjectPlaceholder,
}) => {
  return (
    <div
      className="plain-text-editor-wrapper"
      style={!isEmail ? bodyFieldStyles : styles.plainTextEditorContainer}
      onClick={handleFocus}
    >
      <Editor
        editorState={!isEmail ? bodyState : subjectState}
        width={!isEmail ? PLAIN_WIDTH : RICH_WIDTH}
        onChange={!isEmail ? updateBodyState : updateSubjectState}
        placeholder={
          !isEmail
            ? customBodyPlaceholder || PLACEHOLDER_TEXT.body
            : customSubjectPlaceholder || PLACEHOLDER_TEXT.subject
        }
        plugins={plugins}
      />
      {!isEmail && (
        <MentionSuggestions
          className="mention-suggestions"
          onSearchChange={handleSearchChange}
          suggestions={mentionableData}
        />
      )}
    </div>
  )
}

export default PlainTextEditor



// WEBPACK FOOTER //
// ./src/components/Settings/PlainTextEditor.js